<template>
  <bootstrap-modal
    v-if="showModal"
    class="team-thorn-modal"
    size="lg"
    @modal-close="closeModal"
  >
    <template v-slot:header>
      <div class="team-thorn-modal__header">
        <button
          type="button"
          class="close modal__close-button team-thorn-modal__close-button"
          aria-label="Close"
          @click="closeModal"
        ><span aria-hidden="true">×</span></button>
      </div>
    </template>
    <template v-slot:body>
      <div class="team-thorn-modal__body">
        <div class="row team-thorn-modal__body-row team-thorn-modal__body-row--vertical-align">
          <div class="hidden-xs col-sm-6 col-lg-4 col-lg-offset-2">
            <img
              :src="ImgTeamThornAshton"
              class="responsive-img"
              alt="Team Thorn - Ashton Kutcher"
            >
          </div>
          <div class="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-0 col-lg-4">
            <img
              :src="ImgTeamThornLogo"
              class="responsive-img"
              alt="Team Thorn Logo"
            >
          </div>
        </div>
        <div class="row team-thorn-modal__body-row">
          <div class="col-xs-12">
            <h3 class="team-thorn-modal__body-title">
              Help Ashton <br class="visible-xs"> Defend Children
            </h3>
            <h4>Defending children is a marathon, <br class="visible-sm"> not a sprint.</h4>
            <p>
              Ashton Kutcher and Team Thorn are running the 2022 TCS New York City
              Marathon to eliminate child sexual abuse from the internet. Thorn builds
              technology and programs to defend children from child sexual abuse, and
              build a world where every child can be safe, curious and happy. Your
              donation helps make our goal a reality.
            </p>
            <h4>Donate Now!</h4>
          </div>
        </div>
        <div class="text-center">
          <a
            href="https://ashton-runs.funraise.org/?utm_source=marathon_foto&utm_medium=referral&utm_campaign=nyc_marathon"
            class="button team-thorn-modal__cta-link"
            target="_blank"
            @click="handleCtaClick"
          >
            Help Ashton Defend Children<br>
            DONATE NOW!
          </a>
        </div>
        <div class="text-center">
          <a
            href="#"
            class="team-thorn-modal__close-link"
            @click.prevent="closeModal"
          >Close</a>
        </div>
      </div>
    </template>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@/shared/components/BootstrapModal.vue'
import ImgTeamThornLogo from './assets/team-thorn-logo.png'
import ImgTeamThornAshton from './assets/team-thorn-ashton.jpg'

import googleAnalytics from '@/shared/lib/google-analytics'

export default {
  name: 'TeamThornModal',
  components: {
    BootstrapModal
  },
  data () {
    return {
      ImgTeamThornAshton,
      ImgTeamThornLogo,
      showModal: true
    }
  },
  mounted () {
    googleAnalytics.trackEvent('TeamThornModal', 'open', null)
  },
  methods: {
    handleCtaClick () {
      googleAnalytics.trackEvent('TeamThornModal', 'click', 'Donate Call To Action')
    },
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.team-thorn-modal {
  padding: 20px;

  * {
    font-family: $opensans;
  }

  &__close-button {
    background-image: url('./assets/modal-close.svg') !important;
    width: 36px;
    height: 36px;
  }

  &__header {
    padding: 10px;
  }

  &__body {
    padding: 1rem;
    text-align: center;

    @media screen and (min-width: $screen-sm-min) {
      padding: 3rem;
    }

    &-row {
      margin-bottom: 2rem;

      &--vertical-align {
        @media screen and (min-width: $screen-sm-min) {
          display: flex;
          align-items: center;
        }
      }
    }

    &-title {
      font-size: 2rem;
      font-weight: 800;
      margin: 0 0 2rem 0;
      padding: 0;

      @media screen and (min-width: $screen-sm-min) {
        font-size: 1.8rem;
      }

      @media screen and (min-width: $screen-md-min) {
        font-size: 2rem;
      }

      @media screen and (min-width: $screen-lg-min) {
        font-size: 2.5rem;
      }
    }

    & h4 {
      margin-bottom: 10px;

      @media screen and (min-width: $screen-sm-min) {
        font-size: 1.4rem;
        margin-bottom: 20px;
      }

      @media screen and (min-width: $screen-lg-min) {
        font-size: 1.4rem;
      }
    }

    & p {
      @media screen and (min-width: $screen-sm-min) {
        font-size: 1.2rem;
        line-height: 1.8rem;
      }

      @media screen and (min-width: $screen-lg-min) {
        padding: 0 4rem;
      }
    }
  }

  &__cta-link {
    background: #f87b5e;
    border-radius: 12px;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    height: auto;
    line-height: 2rem;
    margin: 0 auto 2rem auto;
    padding: 10px 20px;
    text-align: center;
    text-transform: none;
    width: 100%;

    @media screen and (min-width: $screen-sm-min) {
      width: auto;
    }
  }

  &__close-link {
    color: #f87b5e;
    font-size: 1.4rem;
    font-weight: 700;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/proofs/index/components/TeamThornModal/TeamThornModal.vue